// src/data/sandaTourData.js - 画像URL統一版
// 共通画像URLオブジェクト
export const COMMON_IMAGES = {
  hero: "https://lxnkiipxzsdpwledlbkp.supabase.co/storage/v1/object/public/experience-images/9a3775b5-5d19-4c03-85ec-4da3bd00c03d/760af57c-38c5-4073-a036-f5218dafc846.jpeg",
  
  experiences: {
    pottery: "https://lxnkiipxzsdpwledlbkp.supabase.co/storage/v1/object/public/experience-images/9a3775b5-5d19-4c03-85ec-4da3bd00c03d/93bf2747-bd30-4587-95da-a6d02e66bead.jpg",
    cuisine: "https://lxnkiipxzsdpwledlbkp.supabase.co/storage/v1/object/public/experience-images/9a3775b5-5d19-4c03-85ec-4da3bd00c03d/1de014e3-403e-4227-8867-c058be2bdf03.jpg",
    tea: "https://lxnkiipxzsdpwledlbkp.supabase.co/storage/v1/object/public/experience-images/9a3775b5-5d19-4c03-85ec-4da3bd00c03d/dc8b2fec-2d3e-412a-bbc9-0662f70de2f6.jpeg"
  },
  
  gallery: [
    "https://lxnkiipxzsdpwledlbkp.supabase.co/storage/v1/object/public/experience-images/9a3775b5-5d19-4c03-85ec-4da3bd00c03d/57c679c9-f950-425f-8b81-632aab76e6d2.jpg", // [0] 伊藤館長
    "https://lxnkiipxzsdpwledlbkp.supabase.co/storage/v1/object/public/experience-images/9a3775b5-5d19-4c03-85ec-4da3bd00c03d/5181234e-ff2c-4a3c-b906-05fb167da1f0.jpg", // [1] 三田陶芸の森。
    "https://lxnkiipxzsdpwledlbkp.supabase.co/storage/v1/object/public/experience-images/9a3775b5-5d19-4c03-85ec-4da3bd00c03d/371b129d-0a99-4c37-8c67-69c71ebf60b4.jpg", // [2] 三田陶芸の森。
    "https://lxnkiipxzsdpwledlbkp.supabase.co/storage/v1/object/public/experience-images/9a3775b5-5d19-4c03-85ec-4da3bd00c03d/00311353-4d0c-45d4-9d66-1e4bb7a7e685.jpeg", // [4] 茶道
    "https://lxnkiipxzsdpwledlbkp.supabase.co/storage/v1/object/public/experience-images/9a3775b5-5d19-4c03-85ec-4da3bd00c03d/e374bcd6-ca14-4171-90a4-953384760ba1.jpeg", // [6] お茶の時間
    "https://lxnkiipxzsdpwledlbkp.supabase.co/storage/v1/object/public/experience-images/9a3775b5-5d19-4c03-85ec-4da3bd00c03d/1de014e3-403e-4227-8867-c058be2bdf03.jpg", // [8] 昼食
    "https://lxnkiipxzsdpwledlbkp.supabase.co/storage/v1/object/public/experience-images/9a3775b5-5d19-4c03-85ec-4da3bd00c03d/760af57c-38c5-4073-a036-f5218dafc846.jpeg"  // [9] 和室
  ]
};

export const sandaTourData = {
  ja: {
    // 日本語
    meta: {
      title: "三田陶芸の森 特別日帰りツアー | 陶芸・和食・茶道体験",
      description: "兵庫県三田市で日本文化の真髄を五感で味わう特別体験。三田青磁と茶道のツアー。",
    },
    hero: {
      mainTitle: "「陶芸」「和食」「茶道」",
      subtitle: "日本文化の真髄を五感で味わう、唯一無二の旅",
      location: "兵庫県三田市 三田青磁と茶道のツアー",
      catchphrase: "プライベート日帰り体験ツアー",
      imageUrl: COMMON_IMAGES.hero
    },
    navigation: {
      overview: "概要",
      schedule: "スケジュール", 
      experience: "三田青磁と茶道のツアー",
      gallery: "ギャラリー",
      contact: "お問い合わせ"
    },
    experiences: [
      {
        id: "pottery",
        icon: "",
        title: "三田青磁体験(陶芸)",
        subtitle: "三田陶芸の森。",
        time: "10:00-11:30",
        description: "三田青磁の歴史と魅力を学び、伊藤瑞宝による指導で皿を製作体験。さらに本来非公開の製造工程を見学。",
        imageUrl: COMMON_IMAGES.experiences.pottery,
        details: []
      },
      {
        id: "cuisine", 
        icon: "",
        title: "昼食　和食コース",
        subtitle: "名店「仁木家」",
        time: "12:00-13:30", 
        description: "昼食は地元食材を活かし、「茶」をテーマにした特別コースを堪能。三田青磁の器でご提供いたします。",
        imageUrl: COMMON_IMAGES.experiences.cuisine,
        details: [
          "※昼食会場の都合により利用できない場合は、同等内容のお食事を別店舗にてご用意いたします。"
        ]
      },
      {
        id: "tea",
        icon: "", 
        title: "本格茶道体験",
        subtitle: "曹洞宗五葉院",
        time: "14:00-16:00",
        description: "三田青磁で本格的な茶道体験。裏千家と三田の地のつながりを紐解きます。お土産は豪華茶道具セット。",
        imageUrl: COMMON_IMAGES.experiences.tea,
        details: [
          "※施設の都合により利用できない場合は、三田陶芸の森。の特設茶室にて体験していただきます。"
        ]
      }
    ],
    gallery: {
      title: "写真ギャラリー",
      subtitle: "ツアーの魅力をお写真でご紹介",
      images: [
        { id: 1, url: COMMON_IMAGES.gallery[0],},
        { id: 2, url: COMMON_IMAGES.gallery[1], },
        { id: 3, url: COMMON_IMAGES.gallery[2], },
        { id: 4, url: COMMON_IMAGES.gallery[3], },
        { id: 5, url: COMMON_IMAGES.gallery[4],},
        { id: 6, url: COMMON_IMAGES.gallery[5], },
        { id: 7, url: COMMON_IMAGES.gallery[6],  },

      ]
    },
    schedule: {
      title: "三田青磁と茶道のツアー",
      items: [
        {
          time: "10:00-11:30",
          title: "三田陶芸の森。",
          description: "三田青磁の歴史と魅力を学び、伊藤瑞宝による指導で皿を製作体験。さらに本来非公開の製造工程を見学。"
        },
        {
          time: "12:00-13:30", 
          title: "名店「仁木家」",
          description: "昼食は地元食材を活かし、「茶」をテーマにした特別コースを堪能。三田青磁の器でご提供いたします。"
        },
        {
          time: "14:00-16:00",
          title: "曹洞宗五葉院", 
          description: "三田青磁で本格的な茶道体験。裏千家と三田の地のつながりを紐解きます。お土産は豪華茶道具セット。"
        }
      ],
      meeting: {
        title: "集合・解散",
        location: "集合　三田陶芸の森。またはJR相野駅",
        dissolution: "解散　現地またはJR相野駅"
      }
    },
    contact: {
      title: "お問い合わせ・お申し込み",
      company: "三田陶芸の森。", 
      address: "〒669-1342 兵庫県三田市四ツ辻720-2",
      phone: "担当: 武石　sandatoujisha@gmail.com",
      qrText: "お申し込み",
      reservationLink: "https://origamiconcierge.jp/ja/experience/e716bc13-a93f-4dba-89a0-62e76ee7ff50"
    }
  },

  en: {
    // English
    meta: {
      title: "Sanda Ceramic Forest Special Day Trip | Pottery, Japanese Cuisine & Tea Ceremony",
      description: "Experience the essence of Japanese culture through pottery, cuisine and tea ceremony in Sanda, Hyogo.",
    },
    hero: {
      mainTitle: "Pottery, Cuisine, and Tea Ceremony",
      subtitle: "An unparalleled journey to experience the essence of Japanese culture through pottery, cuisine, and tea ceremony",
      location: "Hyogo Prefecture, Sanda City - Sanda Celadon and Tea Tour",
      catchphrase: "Private One-Day Experience Tour", 
      imageUrl: COMMON_IMAGES.hero
    },
    navigation: {
      overview: "Overview",
      schedule: "Schedule",
      experience: "Experience",
      gallery: "Gallery",
      contact: "Contact"
    },
    experiences: [
      {
        id: "pottery",
        icon: "",
        title: "Pottery",
        subtitle: "Sanda Tougei no Mori。",
        time: "10:00-11:30",
        description: "Learn about the history and charm of Sanda Celadon, create your own plate under the guidance of master craftsman Ito, and observe the normally private production process.",
        imageUrl: COMMON_IMAGES.experiences.pottery,
        details: []
      },
      {
        id: "cuisine",
        icon: "", 
        title: "Japanese Cuisine",
        subtitle: "Restaurant \"Niki-ya\"",
        time: "12:00-13:30",
        description: "Enjoy a special lunch course themed around \"tea,\" featuring local ingredients and served on Sanda Celadon tableware.",
        imageUrl: COMMON_IMAGES.experiences.cuisine,
        details: [
          "※If the restaurant is unavailable, an equivalent meal will be arranged at another venue."
        ]
      },
      {
        id: "tea",
        icon: "",
        title: "Tea Ceremony", 
        subtitle: "Goyoin Temple",
        time: "14:00-16:00",
        description: "Experience an authentic tea ceremony using Sanda Celadon ware and discover the connection between Sanda and the Urasenke. A luxury tea set will be given as a souvenir.",
        imageUrl: COMMON_IMAGES.experiences.tea,
        details: [
          "※If the venue is unavailable, the experience will be held in a special tea room at Sanda Tougei no Mori。"
        ]
      }
    ],
    gallery: {
      title: "Photo Gallery",
      subtitle: "Discover the charm of our tour through photos",
      images: [
        { id: 1, url: COMMON_IMAGES.gallery[0],},
        { id: 2, url: COMMON_IMAGES.gallery[1], },
        { id: 3, url: COMMON_IMAGES.gallery[2], },
        { id: 4, url: COMMON_IMAGES.gallery[3], },
        { id: 5, url: COMMON_IMAGES.gallery[4],},
        { id: 6, url: COMMON_IMAGES.gallery[5], },
        { id: 7, url: COMMON_IMAGES.gallery[6],  },

      ]
    },
    schedule: {
      title: "Sanda Celadon and Tea Ceremony Tour",
      items: [
        {
          time: "10:00-11:30",
          title: "Sanda Tougei no Mori。", 
          description: "Learn about the history and charm of Sanda Celadon, create your own plate under the guidance of master craftsman Ito, and observe the normally private production process."
        },
        {
          time: "12:00-13:30",
          title: "Restaurant \"Niki-ya\"",
          description: "Enjoy a special lunch course themed around \"tea,\" featuring local ingredients and served on Sanda Celadon tableware."
        },
        {
          time: "14:00-16:00", 
          title: "Goyoin Temple",
          description: "Experience an authentic tea ceremony using Sanda Celadon ware and discover the connection between Sanda and the Urasenke. A luxury tea set will be given as a souvenir."
        }
      ],
      meeting: {
        title: "Meeting / Dismissal",
        location: "Meeting Point: Sanda Tougei no Mori。 or JR Aino Station",
        dissolution: "Dismissal: On-site or JR Aino Station"
      }
    },
    contact: {
      title: "Contact / Reservation",
      company: "Sanda Tougei no Mori。",
      address: "720-2 Yotsutsuji, Sanda City, Hyogo Prefecture 669-1342",
      phone: "Contact: Takeishi (sandatoujisha@gmail.com)", 
      qrText: "Make Reservation",
      reservationLink: "https://origamiconcierge.jp/experience/e716bc13-a93f-4dba-89a0-62e76ee7ff50"
    }
  },

  zh: {
    // 简体中文
    meta: {
      title: "三田陶艺之森特别一日游 | 陶艺·日式料理·茶道体验",
      description: "在兵库县三田市用五感体验日本文化精髓的特别之旅。三田青瓷与茶道之旅。",
    },
    hero: {
      mainTitle: "「陶芸」「和食」「茶道」",
      subtitle: "以五感体验日本文化精髓的独一无二之旅",
      location: "兵库县三田市 三田青瓷与茶道之旅",
      catchphrase: "私人一日体验游",
      imageUrl: COMMON_IMAGES.hero
    },
    navigation: {
      overview: "概要",
      schedule: "行程安排",
      experience: "体验内容",
      gallery: "图片集",
      contact: "联系方式"
    },
    experiences: [
      {
        id: "pottery",
        icon: "",
        title: "陶艺",
        subtitle: "三田陶艺之森。",
        time: "10:00-11:30", 
        description: "学习三田青瓷的历史与魅力，在伊藤大师指导下亲手制作盘子，并参观原本不对外公开的制作工序。",
        imageUrl: COMMON_IMAGES.experiences.pottery,
        details: []
      },
      {
        id: "cuisine",
        icon: "",
        title: "和食",
        subtitle: "名店「仁木家」", 
        time: "12:00-13:30",
        description: "享用以\"茶\"为主题，使用当地食材制作的特别午餐套餐。餐具采用三田青瓷。",
        imageUrl: COMMON_IMAGES.experiences.cuisine,
        details: [
          "※若因场地原因无法使用，将于其他餐厅提供同等内容的餐食。"
        ]
      },
      {
        id: "tea",
        icon: "",
        title: "茶道",
        subtitle: "曹洞宗五叶院",
        time: "14:00-16:00",
        description: "使用三田青瓷茶具体验正宗茶道，探索裏千家与三田地区的渊源。赠送豪华茶具纪念套装。",
        imageUrl: COMMON_IMAGES.experiences.tea,
        details: [
          "※若因设施原因无法使用，将于三田陶艺之森特设茶室体验。"
        ]
      }
    ],
    gallery: {
      title: "图片画廊",
      subtitle: "通过照片了解我们的旅程魅力",
      images: [
        { id: 1, url: COMMON_IMAGES.gallery[0],},
        { id: 2, url: COMMON_IMAGES.gallery[1], },
        { id: 3, url: COMMON_IMAGES.gallery[2], },
        { id: 4, url: COMMON_IMAGES.gallery[3], },
        { id: 5, url: COMMON_IMAGES.gallery[4],},
        { id: 6, url: COMMON_IMAGES.gallery[5], },
        { id: 7, url: COMMON_IMAGES.gallery[6],  },

      ]
    },
    schedule: {
      title: "三田青瓷与茶道之旅",
      items: [
        {
          time: "10:00-11:30",
          title: "三田陶艺之森。",
          description: "学习三田青瓷的历史与魅力，在伊藤大师指导下亲手制作盘子，并参观原本不对外公开的制作工序。"
        },
        {
          time: "12:00-13:30",
          title: "名店「仁木家」", 
          description: "享用以\"茶\"为主题，使用当地食材制作的特别午餐套餐。餐具采用三田青瓷。"
        },
        {
          time: "14:00-16:00",
          title: "曹洞宗五叶院",
          description: "使用三田青瓷茶具体验正宗茶道，探索裏千家与三田地区的渊源。赠送豪华茶具纪念套装。"
        }
      ],
      meeting: {
        title: "集合与解散",
        location: "集合地点：三田陶艺之森。 或 JR相野站",
        dissolution: "解散地点：现场 或 JR相野站"
      }
    },
    contact: {
      title: "咨询・报名",
      company: "三田陶艺之森。",
      address: "〒669-1342 兵库县三田市四辻720-2",
      phone: "负责人：武石 (sandatoujisha@gmail.com)",
      qrText: "预约申请",
      reservationLink: "https://origamiconcierge.jp/experience/e716bc13-a93f-4dba-89a0-62e76ee7ff50"
    }
  },

  tw: {
    // 繁體中文
    meta: {
      title: "三田陶藝之森特別一日遊 | 陶藝·日式料理·茶道體驗",
      description: "在兵庫縣三田市用五感體驗日本文化精髓的特別之旅。三田青瓷與茶道之旅。",
    },
    hero: {
      mainTitle: "「陶藝」「和食」「茶道」",
      subtitle: "以五感體驗日本文化精髓的獨一無二之旅",
      location: "兵庫縣三田市 三田青瓷與茶道之旅",
      catchphrase: "私人一日體驗遊",
      imageUrl: COMMON_IMAGES.hero
    },
    navigation: {
      overview: "概要",
      schedule: "行程安排",
      experience: "體驗內容",
      gallery: "圖片集",
      contact: "聯絡方式"
    },
    experiences: [
      {
        id: "pottery",
        icon: "",
        title: "陶藝",
        subtitle: "三田陶藝之森。",
        time: "10:00-11:30",
        description: "學習三田青瓷的歷史與魅力，在伊藤大師指導下親手製作盤子，並參觀平時不對外開放的製作過程。",
        imageUrl: COMMON_IMAGES.experiences.pottery,
        details: []
      },
      {
        id: "cuisine",
        icon: "",
        title: "和食",
        subtitle: "名店「仁木家」",
        time: "12:00-13:30",
        description: "享用以「茶」為主題，採用當地食材的特別午餐套餐，使用三田青瓷餐具。",
        imageUrl: COMMON_IMAGES.experiences.cuisine,
        details: [
          "※如因場地原因無法使用，將於其他餐廳提供同等內容餐點。"
        ]
      },
      {
        id: "tea",
        icon: "",
        title: "茶道",
        subtitle: "曹洞宗五葉院",
        time: "14:00-16:00",
        description: "以三田青瓷茶具體驗正統茶道，探尋裏千家與三田地區的連結。贈送豪華茶具紀念組。",
        imageUrl: COMMON_IMAGES.experiences.tea,
        details: [
          "※若因設施因素無法使用，將於三田陶藝之森特設茶室體驗。"
        ]
      }
    ],
    gallery: {
      title: "相片畫廊",
      subtitle: "透過照片了解我們的旅程魅力",
      images: [
        { id: 1, url: COMMON_IMAGES.gallery[0],},
        { id: 2, url: COMMON_IMAGES.gallery[1], },
        { id: 3, url: COMMON_IMAGES.gallery[2], },
        { id: 4, url: COMMON_IMAGES.gallery[3], },
        { id: 5, url: COMMON_IMAGES.gallery[4],},
        { id: 6, url: COMMON_IMAGES.gallery[5], },
        { id: 7, url: COMMON_IMAGES.gallery[6],  },

      ]
    },
    schedule: {
      title: "三田青瓷與茶道之旅",
      items: [
        {
          time: "10:00-11:30",
          title: "三田陶藝之森。",
          description: "學習三田青瓷的歷史與魅力，在伊藤大師指導下親手製作盤子，並參觀平時不對外開放的製作過程。"
        },
        {
          time: "12:00-13:30",
          title: "名店「仁木家」",
          description: "享用以「茶」為主題，採用當地食材的特別午餐套餐，使用三田青瓷餐具。"
        },
        {
          time: "14:00-16:00",
          title: "曹洞宗五葉院",
          description: "以三田青瓷茶具體驗正統茶道，探尋裏千家與三田地區的連結。贈送豪華茶具紀念組。"
        }
      ],
      meeting: {
        title: "集合與解散",
        location: "集合地點：三田陶藝之森。 或 JR相野站",
        dissolution: "解散地點：現場 或 JR相野站"
      }
    },
    contact: {
      title: "諮詢・報名",
      company: "三田陶藝之森。",
      address: "〒669-1342 兵庫縣三田市四辻720-2",
      phone: "負責人：武石(sandatoujisha@gmail.com)",
      qrText: "預約申請",
      reservationLink: "https://origamiconcierge.jp/experience/e716bc13-a93f-4dba-89a0-62e76ee7ff50"
    }
  },

  ko: {
    // 한국어
    meta: {
      title: "산다 도예의 숲 특별 당일투어 | 도예·일식·다도 체험",
      description: "효고현 산다시에서 오감으로 느끼는 일본문화의 정수. 산다청자와 다도 투어.",
    },
    hero: {
      mainTitle: "「도예」 「일식」 「다도」",
      subtitle: "오감으로 일본 문화의 진수를 맛보는 유일무이한 여행",
      location: "효고현 산다시 산다 청자와 다도 투어",
      catchphrase: "프라이빗 당일 체험 투어",
      imageUrl: COMMON_IMAGES.hero
    },
    navigation: {
      overview: "개요",
      schedule: "일정",
      experience: "체험내용",
      gallery: "갤러리",
      contact: "문의사항"
    },
    experiences: [
      {
        id: "pottery",
        icon: "",
        title: "도예",
        subtitle: "산다 도예의 숲。",
        time: "10:00-11:30",
        description: "산다 청자의 역사와 매력을 배우고, 이토의 지도로 접시를 제작합니다. 또한 일반에 공개되지 않는 제작 공정을 견학합니다。",
        imageUrl: COMMON_IMAGES.experiences.pottery,
        details: []
      },
      {
        id: "cuisine",
        icon: "",
        title: "일식",
        subtitle: "명점 '니키야'",
        time: "12:00-13:30",
        description: "'차'를 테마로 한 특별한 코스 요리를 지역 식재료로 즐기며, 산다 청자 그릇에 제공됩니다.",
        imageUrl: COMMON_IMAGES.experiences.cuisine,
        details: [
          "※식당 사정에 따라 이용이 불가능할 경우, 동등한 메뉴를 다른 장소에서 제공합니다."
        ]
      },
      {
        id: "tea",
        icon: "",
        title: "다도",
        subtitle: "조동종 고요인 사원",
        time: "14:00-16:00",
        description: "산다 청자 다기(茶器)를 사용해 본격적인 다도를 체험하고, 우라센케와 산다 지역의 인연을 탐구합니다. 기념품으로 고급 다도구 세트를 드립니다.",
        imageUrl: COMMON_IMAGES.experiences.tea,
        details: [
          "※시설 사정에 따라 이용이 불가능할 경우, 산다 도예의 숲 특별 다실에서 체험합니다."
        ]
      }
    ],
    gallery: {
      title: "포토 갤러리",
      subtitle: "사진을 통해 여행의 매력을 느껴보세요",
      images: [
        { id: 1, url: COMMON_IMAGES.gallery[0],},
        { id: 2, url: COMMON_IMAGES.gallery[1], },
        { id: 3, url: COMMON_IMAGES.gallery[2], },
        { id: 4, url: COMMON_IMAGES.gallery[3], },
        { id: 5, url: COMMON_IMAGES.gallery[4],},
        { id: 6, url: COMMON_IMAGES.gallery[5], },
        { id: 7, url: COMMON_IMAGES.gallery[6],  },

      ]
    },
    schedule: {
      title: "산다청자와 다도 투어",
      items: [
        {
          time: "10:00-11:30",
          title: "산다 도예의 숲。",
          description: "산다 청자의 역사와 매력을 배우고, 이토의 지도로 접시를 제작합니다. 또한 일반에 공개되지 않는 제작 공정을 견학합니다。"
        },
        {
          time: "12:00-13:30",
          title: "명점 '니키야'",
          description: "'차'를 테마로 한 특별한 코스 요리를 지역 식재료로 즐기며, 산다 청자 그릇에 제공됩니다."
        },
        {
          time: "14:00-16:00",
          title: "조동종 고요인 사원",
          description: "산다 청자 다기(茶器)를 사용해 본격적인 다도를 체험하고, 우라센케와 산다 지역의 인연을 탐구합니다. 기념품으로 고급 다도구 세트를 드립니다."
        }
      ],
      meeting: {
        title: "집합 및 해산",
        location: "집합: 산다 도예의 숲 또는 JR 아이노역",
        dissolution: "해산: 현지 또는 JR 아이노역"
      }
    },
    contact: {
      title: "문의・신청",
      company: "산다 도예의 숲。",
      address: "〒669-1342 효고현 산다시 요츠쓰지 720-2",
      phone: "담당: 다케이시(sandatoujisha@gmail.com)",
      qrText: "신청",
      reservationLink: "https://origamiconcierge.jp/experience/e716bc13-a93f-4dba-89a0-62e76ee7ff50"
    }
  }
};

// 언어 배열
export const supportedLanguages = ['ja', 'en', 'zh', 'tw', 'ko'];

// 国旗SVGアイコンデータ（韓国国旗修正版）
export const languageFlags = {
  ja: { 
    emoji: '🇯🇵', 
    name: '日本語',
    svg: (
      <svg width="24" height="16" viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="16" fill="#ffffff"/>
        <circle cx="12" cy="8" r="4.8" fill="#BC002D"/>
      </svg>
    )
  },
  en: { 
    emoji: '🇺🇸', 
    name: 'English',
    svg: (
      <svg width="24" height="16" viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="16" fill="#B22234"/>
        <rect width="24" height="1.23" y="1.23" fill="white"/>
        <rect width="24" height="1.23" y="3.69" fill="white"/>
        <rect width="24" height="1.23" y="6.15" fill="white"/>
        <rect width="24" height="1.23" y="8.61" fill="white"/>
        <rect width="24" height="1.23" y="11.08" fill="white"/>
        <rect width="24" height="1.23" y="13.54" fill="white"/>
        <rect width="9.6" height="8.8" fill="#3C3B6E"/>
      </svg>
    )
  },
  zh: { 
    emoji: '🇨🇳', 
    name: '简体中文',
    svg: (
      <svg width="24" height="16" viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="16" fill="#DE2910"/>
        <polygon points="4.8,2.4 6,4.8 3.6,4.8" fill="#FFDE00"/>
        <polygon points="9.6,1.2 10.2,2.4 8.4,2.4" fill="#FFDE00"/>
        <polygon points="9.6,4.8 10.2,6 8.4,6" fill="#FFDE00"/>
        <polygon points="8.4,7.2 9,8.4 7.2,8.4" fill="#FFDE00"/>
        <polygon points="9.6,9.6 10.2,10.8 8.4,10.8" fill="#FFDE00"/>
      </svg>
    )
  },
  tw: { 
    emoji: '🇹🇼', 
    name: '繁體中文',
    svg: (
      <svg width="24" height="16" viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="16" fill="#FE0000"/>
        <rect width="12" height="8" fill="#000095"/>
        <circle cx="6" cy="4" r="2" fill="white"/>
      </svg>
    )
  },
  ko: { 
    emoji: '🇰🇷', 
    name: '한국어',
    svg: (
      <svg width="24" height="16" viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg">
        {/* 白色背景 */}
        <rect width="24" height="16" fill="white"/>
        
        {/* 太極 */}
        <g transform="translate(12, 8)">
          {/* 赤色半円 (上段) */}
          <path d="M -3.5 0 A 3.5 3.5 0 0 1 0 -3.5 A 1.75 1.75 0 0 1 0 0 A 1.75 1.75 0 0 0 3.5 0 Z" fill="#CD2E3A"/>
          {/* 青色半円 (下段) */}
          <path d="M -3.5 0 A 1.75 1.75 0 0 1 0 0 A 1.75 1.75 0 0 0 0 3.5 A 3.5 3.5 0 0 1 -3.5 0 Z" fill="#0047A0"/>
          
          {/* 小円 */}
          <circle cx="1.75" cy="-1.75" r="1.75" fill="#0047A0"/>
          <circle cx="-1.75" cy="1.75" r="1.75" fill="#CD2E3A"/>
        </g>
        
        {/* 乾卦 (右上) */}
        <g transform="translate(18, 4)">
          <rect x="-1" y="-1.5" width="2" height="0.4" fill="black"/>
          <rect x="-1" y="-0.5" width="2" height="0.4" fill="black"/>
          <rect x="-1" y="0.5" width="2" height="0.4" fill="black"/>
          <rect x="-1" y="1.5" width="2" height="0.4" fill="black"/>
        </g>
        
        {/* 坤卦 (左下) */}
        <g transform="translate(6, 12)">
          <rect x="-1" y="-1.5" width="0.7" height="0.4" fill="black"/>
          <rect x="0.3" y="-1.5" width="0.7" height="0.4" fill="black"/>
          <rect x="-1" y="-0.5" width="0.7" height="0.4" fill="black"/>
          <rect x="0.3" y="-0.5" width="0.7" height="0.4" fill="black"/>
          <rect x="-1" y="0.5" width="0.7" height="0.4" fill="black"/>
          <rect x="0.3" y="0.5" width="0.7" height="0.4" fill="black"/>
          <rect x="-1" y="1.5" width="0.7" height="0.4" fill="black"/>
          <rect x="0.3" y="1.5" width="0.7" height="0.4" fill="black"/>
        </g>
        
        {/* 坎卦 (右下) */}
        <g transform="translate(18, 12)">
          <rect x="-1" y="-1.5" width="0.7" height="0.4" fill="black"/>
          <rect x="0.3" y="-1.5" width="0.7" height="0.4" fill="black"/>
          <rect x="-1" y="-0.5" width="2" height="0.4" fill="black"/>
          <rect x="-1" y="0.5" width="0.7" height="0.4" fill="black"/>
          <rect x="0.3" y="0.5" width="0.7" height="0.4" fill="black"/>
          <rect x="-1" y="1.5" width="2" height="0.4" fill="black"/>
        </g>
        
        {/* 離卦 (左上) */}
        <g transform="translate(6, 4)">
          <rect x="-1" y="-1.5" width="2" height="0.4" fill="black"/>
          <rect x="-1" y="-0.5" width="0.7" height="0.4" fill="black"/>
          <rect x="0.3" y="-0.5" width="0.7" height="0.4" fill="black"/>
          <rect x="-1" y="0.5" width="2" height="0.4" fill="black"/>
          <rect x="-1" y="1.5" width="0.7" height="0.4" fill="black"/>
          <rect x="0.3" y="1.5" width="0.7" height="0.4" fill="black"/>
        </g>
      </svg>
    )
  }
};

export default sandaTourData;